export default "__VITE_ASSET__48302dfb__"